import { useTranslation } from 'react-i18next';
import './bookr-shortcodes-page.scss';
import { Button, Input, notification } from 'antd';
import { SvgIcon } from '../../components/svg-icon/svg-icon';
import { NotificationType } from '../../core/types/notification.type';

export const ShortcodesPage: React.FC = () => {
	const { t } = useTranslation();
	const shortCodeBookrCalendar = '[bookr-calendar]';

	const [api, contextHolder] = notification.useNotification();

	const copyShortcodeCalender = () => {
		navigator.clipboard.writeText(shortCodeBookrCalendar);

		api['success' as NotificationType]({
			message: `${t('backEnd.shortcodes.copyShortcode')}`,
		});
	};

	return (
		<>
			{contextHolder}
			<h1>{t('backEnd.shortcodes.headline')}</h1>
			<p>{t('backEnd.shortcodes.description')}</p>
			<Input value={shortCodeBookrCalendar} disabled={true} suffix={<Button icon={<SvgIcon name='copy' />} onClick={copyShortcodeCalender} />} />
		</>
	);
};
